/* eslint-disable react-hooks/set-state-in-effect */
import React, { useState, useEffect } from 'react';
import { leerVehiculo } from '../../constants/vehiculoDeFlota';
import { View, Text, StyleSheet, SafeAreaView, ScrollView, TouchableOpacity, Image, ActivityIndicator, Alert, TextInput, useWindowDimensions, Platform } from 'react-native';
import { Colors, SIZES } from '../../constants/theme';
import { Ionicons } from '@expo/vector-icons';
import ScreenBackground from '../../components/ScreenBackground';
import { GlassView } from 'expo-glass-effect';
import { useRouter } from 'expo-router';
import { firestoreService } from '../../services/firestoreService';
import { useAppStore } from '../../store/useAppStore';
import AvisoVistaPrevia from '../../components/AvisoVistaPrevia';
import { ratingDisplay } from '../../services/ratingUtils';
import { pesos } from '../../utils/dinero';

export default function MarketplaceScreen() {
  const router = useRouter();
  const { width } = useWindowDimensions();
  const isDesktop = width > 768 && Platform.OS === 'web';
  
  const setActiveChatPartner = useAppStore((state) => state.setActiveChatPartner);
  const [cars, setCars] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const unsubscribe = firestoreService.listenToMarketplaceVehicles((vehicles) => {
      setCars(vehicles);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  return (
    <ScreenBackground>
      <SafeAreaView style={styles.safeArea}>
        <View style={styles.header}>
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            {isDesktop && (
              <TouchableOpacity onPress={() => router.replace('/')} style={{ marginRight: 15 }}>
                <Ionicons name="close" size={32} color={Colors.text} />
              </TouchableOpacity>
            )}
            <Text style={styles.title}>Marketplace</Text>
          </View>
        </View>

        <ScrollView contentContainerStyle={styles.container} showsVerticalScrollIndicator={false}>
        <AvisoVistaPrevia que="el marketplace de vehículos" />
          <View style={styles.searchBar}>
            <Ionicons name="search" size={20} color={Colors.textSecondary} style={{ marginRight: 10 }} />
            <TextInput
              placeholder="Buscar marca, modelo o año..."
              placeholderTextColor={Colors.textSecondary}
              value={searchQuery}
              onChangeText={setSearchQuery}
              style={styles.searchInputField}
            />
          </View>

          <Text style={styles.sectionTitle}>Vehículos Disponibles</Text>

          {loading ? (
            <ActivityIndicator size="large" color={Colors.primary} style={{ marginTop: 50 }} />
          ) : cars.filter(car => {
            const query = searchQuery.toLowerCase();
            return (
              car.make?.toLowerCase().includes(query) ||
              car.model?.toLowerCase().includes(query) ||
              car.year?.toString().includes(query)
            );
          }).length === 0 ? (
            <Text style={{color: Colors.textSecondary, textAlign: 'center', marginTop: 50}}>No se encontraron vehículos.</Text>
          ) : (
            cars.filter(car => {
              const query = searchQuery.toLowerCase();
              return (
                car.make?.toLowerCase().includes(query) ||
                car.model?.toLowerCase().includes(query) ||
                car.year?.toString().includes(query)
              );
            }).map((crudo) => {
              // ⚠️ TODO LO DE ABAJO LEÍA EL DOCUMENTO A PELO, Y LA MITAD DE LOS
              // CARROS NO TIENE ESOS CAMPOS. Los dados de alta desde el panel
              // del dueño guardaban `brand` en vez de `make`, y ni `year` ni
              // `carImage`: salían aquí con el TÍTULO EN BLANCO, sin año y con
              // una foto de relleno de un host externo. Ningún chofer los
              // tocaba, y el dueño no podía enterarse porque su propia pantalla
              // sí los leía bien.
              // El alta ya está unificada, pero esos documentos siguen en la
              // base: `leerVehiculo` los repara al leerlos, sin migrar nada.
              const car = leerVehiculo(crudo);
              return (
              <GlassView key={car.id} style={styles.carCard} colorScheme="light">
                {/* FIX AUDIT — La flota guarda la foto como `carImage` (fleet.tsx),
                    pero aquí se leía `car.image` → siempre placeholder. */}
                <Image source={{ uri: car.carImage || 'https://via.placeholder.com/300x200?text=Carro' }} style={styles.carImage} />
                <View style={styles.carInfo}>
                  <View style={styles.carHeaderRow}>
                    <Text style={styles.carTitle}>{car.titulo}</Text>
                    {/* ── NADA DE CINCO ESTRELLAS DE RELLENO ────────────────
                        Antes: `car.rating || '5.0'`. Todo vehículo salía con
                        cinco estrellas sin que nadie lo hubiera alquilado.
                        El 5.0 tampoco venía de una nota: lo escribía a mano la
                        pantalla de flota (`fleet.tsx`), que ya no lo guarda.
                        Ahora manda el ayudante del proyecto: sin ni una nota
                        real dice "Nuevo", igual que la tarjeta de oferta. */}
                    {(() => {
                      const r = ratingDisplay(car.crudo?.rating, car.crudo?.ratingCount);
                      if (r.isNew) {
                        return (
                          <View style={styles.nuevoChip}>
                            <Text style={styles.nuevoChipText}>Nuevo</Text>
                          </View>
                        );
                      }
                      return (
                        <View style={styles.ratingBadge}>
                          <Ionicons name="star" size={14} color="#FFD700" />
                          <Text style={styles.ratingText}>{r.label}</Text>
                        </View>
                      );
                    })()}
                  </View>
                  
                  {/* Sin año no se pinta un «undefined • Disponible». */}
                  <Text style={styles.carSub}>
                    {car.year ? `${car.year} • ` : ''}{car.crudo?.type || car.status}
                  </Text>

                  {/* ══════════════════════════════════════════════════════════
                      EL SELLO, Y POR QUÉ NO LO LLEVAN TODOS
                      ══════════════════════════════════════════════════════════
                      Solo los carros cuya matrícula revisó una persona del
                      equipo. Los creados ANTES de que existiera la revisión no
                      tienen el campo y por eso no lo llevan: siguen
                      publicándose (apagarlos de golpe castigaría a dueños que
                      no han hecho nada), pero el chofer tiene que poder
                      distinguirlos. Un sello que lo llevara todo el mundo no
                      diría nada. */}
                  {car.revision === 'APROBADO' && (
                    <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 6 }}>
                      <Ionicons name="shield-checkmark" size={14} color="#00A86B" />
                      <Text style={{ color: '#00A86B', fontSize: 12, fontWeight: '700', marginLeft: 5 }}>
                        Verificado por Go Safely
                      </Text>
                    </View>
                  )}
                  
                  <View style={styles.carFooterRow}>
                    <Text style={styles.carPrice}>{pesos(car.price)}<Text style={{fontSize: 12, color: Colors.textSecondary}}>/sem</Text></Text>
                    <TouchableOpacity 
                      style={styles.contactBtn}
                      onPress={() => {
                        // FIX AUDIT — Antes se perdía el dueño real (name
                        // hardcodeado 'RentCar VIP', sin ownerId) → el chat no
                        // sabía a quién escribir y las reglas lo rechazaban.
                        // Ahora pasamos car.ownerId para construir el chatId y
                        // el recipientId correctos.
                        setActiveChatPartner({
                          name: car.crudo?.ownerName || 'Dueño del vehículo',
                          vehicle: car.year ? `${car.titulo} (${car.year})` : car.titulo,
                          role: 'CANDIDATE',
                          ownerId: car.crudo?.ownerId,
                        });
                        router.push('/rent-car-chat');
                      }}
                    >
                      <Text style={styles.contactBtnText}>Contactar</Text>
                    </TouchableOpacity>
                  </View>
                </View>
              </GlassView>
              );
            })
          )}

          <View style={{ height: 100 }} />
        </ScrollView>
      </SafeAreaView>
    </ScreenBackground>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: SIZES.padding,
    paddingTop: 60,
    paddingBottom: 15,
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    color: Colors.text,
  },
  filterBtn: {
    width: 45,
    height: 45,
    borderRadius: 22.5,
    backgroundColor: 'rgba(26, 35, 126, 0.1)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    padding: SIZES.padding,
  },
  searchBar: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.05)',
    padding: 15,
    borderRadius: 16,
    marginBottom: 25,
  },
  searchText: {
    color: Colors.textSecondary,
    marginLeft: 10,
    fontSize: 16,
  },
  searchInputField: {
    flex: 1,
    fontSize: 16,
    color: Colors.text,
    padding: 0,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: Colors.text,
    marginBottom: 15,
  },
  carCard: {
    borderRadius: 20,
    marginBottom: 20,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.5)',
  },
  carImage: {
    width: '100%',
    height: 180,
    backgroundColor: '#E0E0E0',
  },
  carInfo: {
    padding: 15,
  },
  carHeaderRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  carTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: Colors.text,
  },
  nuevoChip: {
    backgroundColor: 'rgba(255,149,0,0.15)',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  nuevoChipText: {
    fontSize: 12,
    fontWeight: '800',
    color: '#FF9500',
  },
  ratingBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 215, 0, 0.1)',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  ratingText: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#FF9800',
    marginLeft: 4,
  },
  carSub: {
    fontSize: 14,
    color: Colors.textSecondary,
    marginTop: 4,
    marginBottom: 15,
  },
  carFooterRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  carPrice: {
    fontSize: 20,
    fontWeight: 'bold',
    color: Colors.primary,
  },
  contactBtn: {
    backgroundColor: Colors.primary,
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderRadius: 12,
  },
  contactBtnText: {
    color: '#FFF',
    fontWeight: 'bold',
    fontSize: 14,
  }
});
